// Runtime configuration helper
// Uses window.__CAMPYID_CONFIG__ (from /config.js) with fallback to process.env
// This solves the production deployment issue where build-time env vars are stale

const getBackendUrl = () => {
  // Check if we're in Emergent preview environment (URL contains .preview.emergentagent.com or .emergent.host)
  const isEmergentPreview = typeof window !== 'undefined' && 
    (window.location.hostname.includes('.preview.emergentagent.com') || 
     window.location.hostname.includes('.emergent.host'));
  
  // In Emergent preview, always use the environment variable (set by Emergent)
  if (isEmergentPreview) {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  
  // For production (campyid.com), use the runtime config
  if (typeof window !== 'undefined' && 
      window.__CAMPYID_CONFIG__?.BACKEND_URL && 
      window.__CAMPYID_CONFIG__.BACKEND_URL.trim() !== '') {
    return window.__CAMPYID_CONFIG__.BACKEND_URL;
  }
  
  // Fallback to build-time environment variable
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Export as a constant that's evaluated once at module load
// This ensures consistent behavior across the app
export const BACKEND_URL = getBackendUrl();

export default BACKEND_URL;

